import { apiClient } from "@/lib/apiClient";
import { CouponFilters } from "@/types/coupon/filter";

export const getCoupons = async (
  params: Record<string, string | number | boolean> & CouponFilters,
) => {
  // Convert all values to strings for the API
  const stringParams: Record<string, string> = {};

  Object.entries(params).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      stringParams[key] = String(value);
    }
  });

  return await apiClient.getPaginated(
    "/api/v1/admin/:storeId/coupons",
    stringParams,
  );
};

export const activateCoupon = async (couponId: string) => {
  return await apiClient.put(
    `/api/v1/admin/:storeId/coupons/${couponId}/activate`,
  );
};

export const deActivateCoupon = async (couponId: string) => {
  return await apiClient.put(
    `/api/v1/admin/:storeId/coupons/${couponId}/deactivate`,
  );
};

// Search coupons with pagination and query
export const searchCoupons = async (params: {
  page: number;
  limit: number;
  query: string;
}) => {
  const response = await apiClient.getPaginated(
    "/api/v1/admin/:storeId/coupons/search",
    {
      query: params.query,
    },
  );
  console.log("[searchCoupons] response:", response);
  return response;
};
